<script>
  import { onDestroy } from "svelte";
  import { time } from "./store.js";

  let format;
  $: format = formatTime($time);

  function formatTime(msec) {
    if (!Number.isFinite(msec) || msec < 0) {
      console.log(msec);
      return "";
    }

    const date = new Date(0);
    date.setMilliseconds(msec);
    //return msec;
    return date.toISOString().substr(11, 8);
  }
</script>

<style>
  .clock {
    display: flex;
    justify-content: center;
    font-size: 2rem;
    margin: 1rem;
  }
</style>

<div class="clock">
  {format}
</div>